import { createReducer } from 'redux-starter-kit';
import {
  resetPassword, loadUnauthUser, fetchChangePassword, sendResetPasswordEmail,
} from './passwordUiActions';
import { selectRequest } from '../../../domain/requests/RequestReducer';


/**
 * A Selector for the resetpassword request
 */
export const selectResetPasswordRequest = (state) => {
  const requestId = state.via.ui.passwords.resetPasswordRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the changePassword request
 */
export const selectChangePasswordRequest = (state) => {
  const requestId = state.via.ui.passwords.changePasswordRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the loadUnauthUser request
 */
export const selectLoadUnauthUserRequest = (state) => {
  const requestId = state.via.ui.passwords.loadUnauthUserRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the sendResetPasswordEmail request
 */
export const selectSendResetPasswordEmailRequest = (state) => {
  const requestId = state.via.ui.passwords.sendResetPasswordEmailRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

const initialUsersState = {
  resetPasswordRequestId: null,
};

/**
 * A reducer for the reset-password component in the UI.
 */
const passwordReducer = createReducer(initialUsersState, {

  [resetPassword]: (state, action) => ({
    ...state,
    resetPasswordRequestId: action.payload,
  }),

  [fetchChangePassword]: (state, action) => ({
    ...state,
    changePasswordRequestId: action.payload,
  }),

  [loadUnauthUser]: (state, action) => ({
    ...state,
    loadUnauthUserRequestId: action.payload,
  }),

  [sendResetPasswordEmail]: (state, action) => ({
    ...state,
    sendResetPasswordEmailRequestId: action.payload,
  }),

});


export default passwordReducer;
